// Builds the sample /api/webhooks/event payload shown beside the trigger form.
// Mirrors the dispatch envelope: one object = single call, an array = batch.

export interface PreviewVariable {
  name: string
}

function sampleValue(name: string): string {
  return `<${name}>`
}

export function buildPayloadEntry(
  variables: PreviewVariable[],
): Record<string, string> {
  const entry: Record<string, string> = {}
  for (const variable of variables) {
    if (variable.name) entry[variable.name] = sampleValue(variable.name)
  }
  return entry
}

export function buildPayloadPreview(params: {
  eventName: string
  variables: PreviewVariable[]
}): { single: string; batch: string } {
  const event = params.eventName || 'your.event.name'
  const entry = buildPayloadEntry(params.variables)
  const single = JSON.stringify({ event, data: entry }, null, 2)
  const batch = JSON.stringify({ event, data: [entry, entry] }, null, 2)
  return { single, batch }
}
